import { absoluteLogoUrl, publicLandingUrl } from "./_shared";

/* ---------------------------------------------------------------------------
 * Live Preview — mini /[slug] landing mock. Updates in real time from local
 * form state.
 * ------------------------------------------------------------------------- */
export function LivePreview({ name, town, color, logoUrl, slug }) {
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  // Always render the customer-facing public origin so what the admin
  // sees here matches the URL encoded into the QR code below.
  const landingUrl = publicLandingUrl(slug);
  return (
    <div className="sticky top-24" data-testid="live-preview">
      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">
        Live landing preview
      </p>
      <div
        className="rounded-lg overflow-hidden border border-zinc-200 bg-white shadow-sm"
        data-testid="live-preview-card"
      >
        <div
          className="h-24 flex items-end px-5 pb-4"
          style={{ backgroundColor: color || "#0038FF" }}
        >
          <p className="text-white text-xs font-semibold uppercase tracking-[0.2em] opacity-90">
            Dugsy&apos;s Football Challenge
          </p>
        </div>
        <div className="px-5 -mt-8 pb-5">
          <div
            className="w-16 h-16 rounded-md bg-white shadow-md border border-zinc-200 flex items-center justify-center overflow-hidden"
            data-testid="live-preview-logo"
          >
            {logoUrl ? (
              <img src={absoluteLogoUrl(logoUrl)} alt="" className="max-w-full max-h-full object-contain" />
            ) : (
              <span className="font-heading text-2xl font-bold text-zinc-950">{initial}</span>
            )}
          </div>
          <h4 className="font-heading text-xl font-bold text-zinc-950 mt-3" data-testid="live-preview-name">
            {name || "Your venue name"}
          </h4>
          {town && <p className="text-xs text-zinc-500">{town}</p>}
          <div className="mt-4 rounded border border-zinc-200 bg-zinc-50 p-3">
            <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-500">Next match</p>
            <p className="text-sm text-zinc-800 mt-1">Predict the stats — win the pot.</p>
          </div>
          <button
            type="button"
            className="mt-4 w-full h-10 rounded-sm text-white text-sm font-semibold tracking-tight"
            style={{ backgroundColor: color || "#0038FF" }}
          >
            Register &amp; play
          </button>
          {landingUrl ? (
            <p className="mt-3 text-[11px] text-zinc-500 break-all" data-testid="live-preview-url">
              {landingUrl}
            </p>
          ) : (
            <p className="mt-3 text-[11px] text-zinc-400">Set a slug to preview the landing URL</p>
          )}
        </div>
      </div>
    </div>
  );
}
